import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const accountDetailsRouteRef = createRouteRef({
  params: ['billingID'],
});

export const accountsQueryRouteRef = createRouteRef();

export const entitlementDetailsRouteRef = createRouteRef({
  params: ['entitlementID'],
});
